import Accordion from '@/common/components/Accordion'
import InfoField from '@/common/components/InfoField'

interface FipeAdditionalsEquipmentsAccordionProps {
  additionalEquipments?: string[]
}

export default function FipeAdditionalsEquipmentsAccordion({ 
  additionalEquipments 
}: FipeAdditionalsEquipmentsAccordionProps) {
  return (
    <Accordion
      name="AdditionalEquipments"
      head="Equipamentos Opcionais"
      defaultOpen
      body={
        <div className='grid grid-cols-3 gap-1'>
          {additionalEquipments && additionalEquipments.length > 0 ? (
            additionalEquipments.map((item, index) => (
              <InfoField 
                key={`${item}-${index}`} 
                value={item} 
              />
            ))
          ) : (
            <InfoField value={null} />
          )}
        </div>
      }
    />
  )
}